import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=6c05b53f&scoped=true"
import script from "./Diff.vue?vue&type=script&lang=js"
export * from "./Diff.vue?vue&type=script&lang=js"
import style0 from "./Diff.vue?vue&type=style&index=0&id=6c05b53f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c05b53f",
  null
  
)

export default component.exports